import { Outlet } from "react-router-dom";
import { useState } from "react";
import VolunteerSidebar from "./VolunteerSidebar";
import LogoutWatcher from "../../Utils/LogoutWatcher";
import Header from "../Utils/Header";
import { useGlobalContext } from "../../../GlobalContext";

export default function VolunteerLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { showOld, setShowOld } = useGlobalContext();

  return (
    <div className="flex h-screen overflow-hidden">

      {/* Logout Watcher */}
      <LogoutWatcher type="volunteer" />

      {/* Sidebar */}
      <VolunteerSidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />

      {/* Right Section */}
      <div className="flex flex-col flex-1 overflow-hidden">

        {/* Header */}
        <Header
          showOld={showOld}
          setShowOld={setShowOld}
        />

        {/* Page Content */}
        <div className="flex-1 overflow-auto  p-4">
          <Outlet />
        </div>

      </div>

    </div>
  );
}